export const actionTypesView = {
    //actions view
    changeView: 'CHANGE_VIEW',
}
